import { Error } from 'lib/types/global';
import 'lib/types/deliveryAreas';
import { camelCase } from 'lib/utils/objectSerializer';

import {
  API_SAVE_DELIVERY_AREA_REQUEST,
  API_SAVE_DELIVERY_AREA_SUCCESS,
  API_SAVE_DELIVERY_AREA_FAILURE,
  API_DELETE_DELIVERY_DISTANCE_REQUEST,
  API_DELETE_DELIVERY_DISTANCE_SUCCESS,
  API_DELETE_DELIVERY_DISTANCE_FAILURE,
} from './actionTypes';
import { DeliveryAreasV3MultiAreaAction } from './actions';

export interface DeliveryAreasV3MultiAreaState {
  loading: boolean;
  saving: boolean;
  deleting: boolean;
  error?: Error;
}

export const initialState: DeliveryAreasV3MultiAreaState = {
  loading: false,
  saving: false,
  deleting: false,
};

export default function deliveryAreasReducer(
  state: DeliveryAreasV3MultiAreaState = initialState,
  action: DeliveryAreasV3MultiAreaAction,
): DeliveryAreasV3MultiAreaState {
  switch (action.type) {
    case API_SAVE_DELIVERY_AREA_REQUEST:
      return { ...state, saving: true, error: undefined };
    case API_DELETE_DELIVERY_DISTANCE_REQUEST:
      return { ...state, deleting: true, error: undefined };

    case API_SAVE_DELIVERY_AREA_FAILURE:
      return { ...state, saving: false, error: camelCase(action.payload) };
    case API_DELETE_DELIVERY_DISTANCE_FAILURE:
      return { ...state, deleting: false, error: camelCase(action.payload) };

    case API_SAVE_DELIVERY_AREA_SUCCESS: {
      return {
        ...state,
        saving: false,
      };
    }

    case API_DELETE_DELIVERY_DISTANCE_SUCCESS: {
      return {
        ...state,
        deleting: false,
      };
    }

    default:
      return state;
  }
}
